import { render, staticRenderFns } from "./TimeLimitSetting.vue?vue&type=template&id=61d6a3ab&scoped=true"
import script from "./TimeLimitSetting.vue?vue&type=script&lang=js"
export * from "./TimeLimitSetting.vue?vue&type=script&lang=js"
import style0 from "./TimeLimitSetting.vue?vue&type=style&index=0&id=61d6a3ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6a3ab",
  null
  
)

export default component.exports